/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/core";
import { Box } from "@material-ui/core";
import { useI18n } from "hooks/i18n/i18n";
import { CheckIcon } from "ui/CheckIcon";

type Props = {
  showToast: boolean;
};

export const AddedToCartToast: React.FC<Props> = ({ showToast }) => {
  const styles = purchasedToastDesign({ showToast });
  const { t } = useI18n();
  return (
    <Box css={styles.container}>
      <CheckIcon css={styles.icon} />
      <Box css={styles.textGroup}>
        <p css={styles.heading}>
          {t("streaming.commerceAddedToCartToast.heading")}
        </p>
        <p css={styles.text}>{t("streaming.commerceAddedToCartToast.text")}</p>
      </Box>
    </Box>
  );
};

type PurchasedToastDesignProps = {
  showToast: boolean;
};

const purchasedToastDesign = ({ showToast }: PurchasedToastDesignProps) => {
  const container = css`
    position: absolute;
    bottom: 24px;
    left: 50%;
    gap: 12px;
    transform: translate(-50%, ${showToast ? "-50%" : "-40%"});
    z-index: 20;
    padding: 16px;
    background-color: #f0f0f0;
    display: flex;
    border-radius: 4px;
    min-width: 280px;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
    opacity: ${showToast ? 1 : 0};
    visibility: ${showToast ? "visible" : "hidden"};
    transition: all 0.3s ease-in-out;
  `;

  const textGroup = css`
    display: flex;
    flex-direction: column;
  `;

  const icon = css`
    size: 16px;
    color: #000000;
  `;

  const heading = css`
    padding-top: 2px;
    font-size: 16px;
    font-weight: 700;
    color: #000000;
  `;

  const text = css`
    font-size: 14px;
    color: #333333;
    margin-top: 6px;
    line-height: 20px;
    width: 226px;
  `;

  return {
    container,
    icon,
    textGroup,
    heading,
    text,
  };
};
